import globalStyles from "./globalStyles"

import collections from "./collections"
import cAccorditabs from "./cAccorditabs"
import cArticle from "./cArticle"
import cButton from "./cButton"
import cContentButtons from "./cContentButtons"
import cInlineSearch from "./cInlineSearch"
import cTabs from "./cTabs"
import profileForm from "./profileForm"
import richPageHeader from "./richPageHeader"
import showcaseGrid from "./showcaseGrid"
import cMviewer from "./cMviewer"
import cResults from "./cResults"
import contribute from "./contribute"
import forms from "./forms"
import cCheckbox from "./cCheckbox"
import badge from "./badge"
import wavesurferСontrol from "./wavesurferСontrol"
import siteHeader from "./siteHeader"
import pOffPage from "./pOffPage"
import userSets from "./userSets"
import buttonDropdown from "./buttonDropdown"
import publicSets from "./publicSets"
import cShare from "./cShare"
import cTypeselect from "./cTypeselect"
import siteFooter from "./siteFooter"
import misc from "./misc"
import modal from "./modal"
import create from "./create"
import cComment from "./cComment"

export default {
  default: [
    globalStyles,
    // richPageHeader,
    // cTabs,
    // profileForm,
    // collections,
    // showcaseGrid,
    // cArticle,
    // cContentButtons,
    // cInlineSearch,
    // cMviewer,
    cResults,
    // contribute,
    // forms,
    // cAccorditabs,
    // cCheckbox,
    // badge,
    // wavesurferСontrol,
    // cButton,
    // siteHeader,
    pOffPage
    // userSets,
    // buttonDropdown,
    // publicSets,
    // cShare,
    // cTypeselect,
    // siteFooter,
    // misc,
    // modal,
    // create,
    // cComment
  ],
  type1: [
    globalStyles,
    richPageHeader,
    cTabs,
    profileForm,
    collections,
    showcaseGrid,
    cArticle,
    cContentButtons,
    cInlineSearch,
    cMviewer,
    cResults,
    contribute,
    forms,
    cAccorditabs,
    cCheckbox,
    badge,
    wavesurferСontrol,
    cButton,
    siteHeader,
    pOffPage,
    userSets,
    buttonDropdown,
    publicSets,
    cShare,
    cTypeselect,
    siteFooter,
    misc,
    modal,
    create,
    cComment
  ]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/config.js